import React from "react";
import autoBind from 'react-autobind';
import { Layout, Button, message } from 'antd';
import PageHeader from '@/components/PageHeader/PageHeader';
//
import CustomComponent from '@/components/CustomComponent';
import WhiteBox from '@/views/commonComponents/WhiteBox';
import Utils from '@/components/Utils';
import CommonLoadingView from '@/views/commonComponents/CommonLoadingView';
import Globals from "@/config/Globals";
import config from "@/config/config";
//
import AdminAdminsForm from './admin/AdminAdminForm';
//
export default class AdminProfileView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.adminID = this.props.app.sharedCache().getUser().id;
    this.state = { isLoading: false, adminObj: null };
  }

  componentDidMount() {
    document.title = `${config.ApplicationName} - Profile`;
    this._fetch();
  }

  async handleSubmit() {
    const formData = await this.form.validateFields();
    if (formData) {
      //Check if changing password, if yes, prompt
      if (this.state.adminObj && this.state.adminObj.email != formData.email) {
        const confirmation = await this.props.app.alertController.showPromptAlert('Attention!', `Admin email will be updated to "${formData.email}". Are you sure you want to update it? (type the new email address to confirm)`);
        if (confirmation != formData.email) return;
      }
      //Update it
      this._update(formData);
    }
  }
  
  render() {
    return (
      <Layout.Content className="pageContent">
        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader title="Profile" onBack={() => window.history.back()} extra={[<Button key="1" onClick={this.handleSubmit} type='primary'>Save</Button>]} />
        <Layout.Content>
          <WhiteBox>
            <AdminAdminsForm isProfile app={this.props.app} {...Utils.propagateRef(this, 'form')} />
          </WhiteBox>
        </Layout.Content>
      </Layout.Content>
    )
  }
  /* private API */
  async _fetch() {
    this.startLoading();
    //request
    const resp = await this.props.app.api.admins.getByID(this.adminID);
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body) {
      this.form.setFields(resp.body);
      this.setState({ adminObj: resp.body, isLoading: false });
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      this.setState({ adminObj: null, isLoading: false });
    }
  }
  async _update(data) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.admins.update({
      id: this.adminID,
      country: Globals.DefaultAdminCountry,
      ...data,
    });
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body) {
      message.success('Profile successfully updated!');
      await this._fetch();
      this.props.app.refreshConfig();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      this.stopLoading(true);
    }
  }
}
